// import { useEffect, useState } from 'react'
// import Cookies from 'js-cookie'

// export default function CookieConsent() {
//   const [showBanner, setShowBanner] = useState(false)

//   useEffect(() => {
//     const cookieConsent = Cookies.get('cookieConsent')
//     if (!cookieConsent) {
//       setShowBanner(true)
//     }
//   }, [])

//   const acceptCookies = () => {
//     Cookies.set('cookieConsent', 'true', { expires: 365 })
//     setShowBanner(false)
//   }

//   const rejectCookies = () => {
//     Cookies.set('cookieConsent', 'false', { expires: 365 })
//     setShowBanner(false)
//   }

//   if (!showBanner) return null

//   return (
//     <div className='cookie-banner'>
//       <div className='container'>
//         <div className='d-flex align-items-center flex-column flex-md-row'>
//           <div
//             style={{
//               display: 'flex',
//               flexDirection: 'column'
//             }}
//           >
//             <h4>Cookies</h4>
//             <p>
//               This website uses cookies to improve your experience. Do you
//               accept?
//             </p>
//             <p>
//               We use cookies to help our website function properly, for
//               analytics, marketing and to personalise the content you see. By
//               accepting, you agree to the use of all of these cookies.
//             </p>
//           </div>
//           <div className='cookie-button-container'>
//             <button className='cookie-button accept' onClick={acceptCookies}>
//               Accept
//             </button>
//             <button className='cookie-button accept' onClick={rejectCookies}>
//               Reject
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

import { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { usePathname } from 'next/navigation'

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    // ❌ Do NOT show cookie banner on property-enquiry page
    if (pathname === '/property-enquiry') {
      setShowBanner(false)
      return
    }

    const cookieConsent = Cookies.get('cookieConsent')
    if (!cookieConsent) {
      setShowBanner(true)
    }
  }, [pathname])

  const acceptCookies = () => {
    Cookies.set('cookieConsent', 'true', { expires: 365 })
    setShowBanner(false)
  }

  const rejectCookies = () => {
    Cookies.set('cookieConsent', 'false', { expires: 365 })
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <div className='cookie-banner'>
      <div className='container'>
        <div className='d-flex align-items-center flex-column flex-md-row'>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h4>Cookies</h4>
            <p>
              This website uses cookies to improve your experience.
            </p>
            <p>
              We use cookies for essential functionality, analytics, and
              personalisation. By accepting, you agree to the use of cookies.
            </p>
          </div>

          <div className='cookie-button-container'>
            <button className='cookie-button accept' onClick={acceptCookies}>
              Accept
            </button>
            <button className='cookie-button reject' onClick={rejectCookies}>
              Reject
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
